import React from 'react';

interface Props {
  isOpen: boolean;
  onDiscard: () => void;
  onContinue: () => void;
}

export const UnsavedChangesModal: React.FC<Props> = ({ isOpen, onDiscard, onContinue }) => {
  if (!isOpen) return null;

  return (
    <div
      data-testid="unsaved-changes-modal"
      style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)', zIndex: 50, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }}
    >
      <div style={{ background: '#fff', borderRadius: '16px', width: '90%', maxWidth: '480px', padding: '32px', boxShadow: '0 20px 50px rgba(15,23,42,0.25)' }}>
        <div style={{ fontSize: '18px', fontWeight: 700, color: '#0F172A', marginBottom: '10px' }}>
          保存されていない変更があります
        </div>
        <div style={{ fontSize: '14px', color: '#64748B', lineHeight: 1.7, marginBottom: '28px' }}>
          このページを離れると、編集中の内容は保存されません。変更を破棄してもよろしいですか？
        </div>
        <div style={{ display: 'flex', gap: '12px' }}>
          <button
            data-testid="save-button"
            onClick={onContinue}
            style={{ flex: 1, background: '#fff', color: '#0F172A', border: '1px solid #E2E8F0', borderRadius: '8px', padding: '12px 20px', fontSize: '14px', fontWeight: 600, cursor: 'pointer' }}
          >
            このページに留まる
          </button>
          <button
            data-testid="discard-button"
            onClick={onDiscard}
            style={{ flex: 1, background: '#DC2626', color: '#fff', border: 'none', borderRadius: '8px', padding: '12px 20px', fontSize: '14px', fontWeight: 700, cursor: 'pointer' }}
          >
            変更を破棄して移動
          </button>
        </div>
      </div>
    </div>
  );
};
